import { render, staticRenderFns } from "./ProjectEditTabInformation.vue?vue&type=template&id=93bb9584"
import script from "./ProjectEditTabInformation.vue?vue&type=script&lang=js"
export * from "./ProjectEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./ProjectEditTabInformation.vue?vue&type=style&index=0&id=93bb9584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports